(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gw-finder"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('gw-finder')) {
 customElements.define('gw-finder', class extends HTMLElement {
  connectedCallback() {
   if (this.ready) return;
   this.ready = true;
   const controls = this.querySelector('.gw-filters');
   if (!controls) return;
   controls.hidden = false;
   const update = (value, announce) => {
    let count = 0;
    this.querySelectorAll('[data-gw-item]').forEach(item => {
     const show = (item.dataset.gwMoods || '').split(' ').includes(value);
     item.hidden = !show;
     if (show) count++;
    });
    controls.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gwFilter === value)));
    const status = this.querySelector('[data-gw-status]');
    if (announce) status.textContent = count + ' ' + status.dataset.label;
   };
   controls.addEventListener('click', event => {
    const button = event.target.closest('button[data-gw-filter]');
    if (button) update(button.dataset.gwFilter, true);
   });
   update('start', false);
  }
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.spacer = document.createElement('div');
      this.spacer.setAttribute('role', 'presentation');
      this.spacer.style.display = 'block';
      this.spacer.style.height = '0px';
      this.header.before(this.spacer);
      this.measureHeader = () => {
        const wasCompact = this.isCompact;
        if (wasCompact) this.reset();
        this.expandedHeight = this.header.offsetHeight;
        this.compactAfter = this.header.getBoundingClientRect().bottom + window.scrollY;
        if (wasCompact) this.compact();
        this.onScroll();
      };
      this.isCompact = false;
      this.ticking = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.onResizeHandler = this.measureHeader;
      window.addEventListener('resize', this.onResizeHandler, { passive: true });
      this.resizeObserver = new ResizeObserver(() => {
        if (!this.isCompact) this.measureHeader();
      });
      this.resizeObserver.observe(this.header);
      this.measureHeader();
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      this.resizeObserver.disconnect();
      cancelAnimationFrame(this.scrollFrame);
      this.spacer.remove();
    }

    onScroll() {
      if (this.ticking || (this.predictiveSearch && this.predictiveSearch.isOpen)) return;

      this.ticking = true;
      this.scrollFrame = requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const compactAfter = Math.max(this.compactAfter || 0, 72);
        const shouldCompact = scrollTop > compactAfter - (this.isCompact ? 24 : 0);

        if (shouldCompact !== this.isCompact) {
          this.isCompact = shouldCompact;

          if (shouldCompact) {
            this.compact();
          } else {
            this.reset();
          }
        }

        this.ticking = false;
      });
    }

    compact() {
      this.spacer.style.height = `${this.expandedHeight}px`;
      this.header.classList.add('shopify-section-header-sticky', 'gw-header-compact');
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-hidden1');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reset() {
      this.spacer.style.height = '0px';
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-hidden1',
        'shopify-section-header-sticky',
        'gw-header-compact',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-announcementbar"] && !Shopify.designMode) return;
  try {
    
  const marqueeAnnouncement = document.querySelector('.section-marquee-announcement');
  document.documentElement.style.setProperty('--marquee-height', `${marqueeAnnouncement.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();
})();
